import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from '../services/permission';

export const permissionResolver: ResolveFn<Observable<string>> = (
  route,
  state,
) => {
  const permissionService = inject(PermissionService);
  return permissionService.getPermissions();
};
